export default "__VITE_ASSET__C9Nx40Ge__"